import React from 'react';
import PropTypes from 'prop-types';
import { connectStats } from 'react-instantsearch-dom';
import Typography from '../../Typography';

const Stats = ({ nbHits, label }) => (
  <Typography variant="body-small" color="gray-af-90">
    {label.replace('{n}', nbHits.toLocaleString())}
  </Typography>
);

Stats.propTypes = {
  label: PropTypes.string,
  nbHits: PropTypes.number,
};

Stats.defaultProps = {
  label: '{n}',
  nbHits: 0,
};

export default connectStats(Stats);
